import * as Sentry from '@sentry/react';

import { Error } from '../../../shared/components/UI/Error/Error';

import { useSidepanel } from '../../../shared/contexts/Sidepanel.provider';
import type { DocumentChunk } from '../../../shared/entities/DocumentChunk';
import type { TengoDocument } from '../../../shared/entities/TengoDocument';
import type { SourceSidepanelContext } from '../components/SourceSidePanel';
import { SourceSidePanel } from '../components/SourceSidePanel';

export function useSourceSidePanel({
  sources,
  documents,
}: {
  sources?: DocumentChunk[];
  documents: Pick<
    TengoDocument,
    'prettyName' | 'S3FileURL' | 'S3PreviewFileURL'
  >[];
}) {
  const { togglePanel, closePanel, getPanelContext } =
    useSidepanel<SourceSidepanelContext>({});
  const panelContext = getPanelContext();

  const openPanel = (selectedSource: DocumentChunk) => {
    togglePanel({
      content: (
        <Sentry.ErrorBoundary fallback={<Error />}>
          <SourceSidePanel
            documents={documents}
            sources={sources}
            closePanel={closePanel}
          />
        </Sentry.ErrorBoundary>
      ),
      initialData: { selectedSource },
    });
  };

  return { openPanel, closePanel, panelContext };
}
